import { Fragment } from 'react';

import { flattenImageAsset } from '../../../lib/contentful/selectors';
import Link from '../../Link';
import Container from '../../Container';
import { CloudinaryImage } from '../../CloudinaryImage';
import RichText from '../../RichText';
import { Copyright } from '../Copyright';
import { Legal } from '../Legal';

import styles from './styles.module.scss';

export const Product = ({
  theme,
  primaryMenu,
  secondaryMenu,
  footerMenu,
  legalMenu,
  footerLogo,
  copyrightStartYear,
  companyLegalName,
  footerLogoCaption,
  footerMenuCaption,
}) => (
  <footer role="contentinfo">
    <Container className={styles.container}>
      <Fragment>
        {!!footerLogoCaption && (
          <p className={styles.logoTitle}>{footerLogoCaption}</p>
        )}
        <Link theme={theme} to="/">
          <CloudinaryImage
            {...flattenImageAsset(footerLogo)}
            className={styles.logo}
          />
        </Link>
        <nav className={styles.links} role="navigation">
          {!!footerMenuCaption && (
            <h4 className={styles.linksTitle}>{footerMenuCaption}</h4>
          )}
          <ul className={styles.primaryMenu}>
            {primaryMenu.map((link) => (
              <li key={link.sys.id}>
                <Link theme={theme} link={link} />
              </li>
            ))}
          </ul>
          <ul className={styles.secondaryMenu}>
            {footerMenu &&
              footerMenu.map((row, index) => (
                <RichText key={`${row.sys.id}-${index}`} content={row} />
              ))}
          </ul>
          <ul className={styles.secondaryMenu}>
            {secondaryMenu.map((link) => (
              <li key={link.sys.id}>
                <Link theme={theme} link={link} />
              </li>
            ))}
          </ul>
        </nav>
      </Fragment>
      <Copyright
        companyLegalName={companyLegalName}
        copyrightStartYear={copyrightStartYear}
      />
      <Legal legalMenu={legalMenu} theme={theme} />
    </Container>
  </footer>
);
